import { render, staticRenderFns } from "./pendingcr.vue?vue&type=template&id=2fe257d2&scoped=true"
import script from "./pendingcr.vue?vue&type=script&lang=js"
export * from "./pendingcr.vue?vue&type=script&lang=js"
import style0 from "./pendingcr.vue?vue&type=style&index=0&id=2fe257d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe257d2",
  null
  
)

export default component.exports